import React, { HTMLAttributes } from 'react';

const Tenant = ({ className }: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 36 33"
  >
    <path
      d="M12.519 22.222a.98.98 0 0 0-1.343-.338 13.445 13.445 0 0 0-6.149 8.346c-.126.526-.527 1.77.473 1.27.526.126.404-.062.48-.062.442 0 .696.312.951-.75a11.476 11.476 0 0 1 5.25-7.124.979.979 0 0 0 .338-1.342ZM18.02 20c-1.046 0-2.087.122-3.096.36a.979.979 0 1 0 .452 1.906c.86-.205 1.75-.308 2.645-.308a.979.979 0 0 0 0-1.958Z"
      fill="#000"
    />
    <path
      d="M22.799 16.615a9 9 0 1 0-9.598 0c-2.972.777-5.71 2.269-7.929 4.364C2.147 23.931.29 27.856.032 32.001-.004 32.55.447 33 1 33h34c.552 0 1.003-.448.969-1-.258-4.144-2.116-8.07-5.241-11.02-2.219-2.096-4.957-3.588-7.93-4.365ZM25 9a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm4.355 13.433c2.48 2.342 4.042 5.359 4.502 8.567H2.143c.46-3.208 2.023-6.225 4.502-8.567C9.638 19.607 13.721 18 18 18c4.28 0 8.362 1.607 11.355 4.433Z"
      fill="#000"
    />
  </svg>
);

export default Tenant;
